/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';

import Icon from '../../../../../components/Icon';
import PeriodField from '../../../../../components/Filter/FilterType/PeriodField';
import PaginatedMultiSelect from '../../../../../components/PaginatedMultiSelect';

import {
  DropDownContainer,
  FilterDropdownButton,
  ButtonTitleContainer,
  ClearFilters,
} from './styles';

const DrawerFilterType = ({
  isOpen,
  options,
  value,
  name,
  placeholder,
  onChange,
  alwaysShowPlaceholder,
  bodyClass,
  identifier,
  newLabel,
  onClear,
  toggleOverlay,
  alignDropdownRight,
  hasNextPage,
  isNextPageLoading,
  loadNextPage,
  renderLeft,
  type,
  searchTerm,
  onSearchByTerm,
}) => {
  const [inputValue, setInputValue] = useState('');

  const _onHandlerClick = () => {
    toggleOverlay(identifier);
  };

  const filteredOptions =
    options &&
    options
      .filter(item => {
        if (!inputValue) return true;
        if (item.name.includes(inputValue)) {
          return true;
        }
        return false;
      })
      .map(item => item);

  const isItemLoaded = index =>
    !hasNextPage || index < (filteredOptions || []).length;

  return (
    <div
      className={`FilterComponent__root${` ${bodyClass}` || ''}${
        isOpen ? ' FilterComponent__root--open' : ''
      }`}
    >
      <FilterDropdownButton
        className="FilterComponent__handle"
        title={
          value &&
          value.length > 0 &&
          `${name}: ${
            value instanceof Array
              ? value.map(val => val.name.trim()).join(', ')
              : value.trim()
          }`
        }
      >
        {value && value.length > 0 && <Icon name="filter" />}
        <ButtonTitleContainer onClick={() => _onHandlerClick()}>
          <span className="FilterComponent__handle-desc">
            {alwaysShowPlaceholder ? placeholder : newLabel}
          </span>
          <Icon
            className="FilterComponent__handle-icon"
            name="arrow_drop_down"
          />
        </ButtonTitleContainer>
        {value && (value.length > 0 || Object.keys(value).length) ? (
          <ClearFilters onClick={() => onClear(false)}>
            <span>limpar filtro</span>
            <Icon name="close" />
          </ClearFilters>
        ) : null}
      </FilterDropdownButton>
      <DropDownContainer
        className={`FilterComponent__dropdown${
          alignDropdownRight ? ' FilterComponent__dropdown--align-right' : ''
        }`}
      >
        {isOpen && (
          <div style={{ width: '100%' }}>
            {type && type === 'period' && (
              <PeriodField onChangeValue={onChange} {...value} />
            )}
            {type && type === 'multiselect' && (
              <div style={{ width: '100%' }}>
                <div style={{ overflowY: 'scroll', maxHeight: '180px' }}>
                  {options &&
                    options.map((option, index) => (
                      <div
                        style={{ display: 'flex', flex: 1, marginBottom: 8 }}
                      >
                        {renderLeft ? renderLeft(index) : null}
                        <div style={{ display: 'flex', flex: 1 }}>
                          {option.name}
                        </div>
                        <input
                          type="checkbox"
                          checked={value.some(val => val.id === option.id)}
                          onChange={() => {
                            if (value.some(val => val.id === option.id)) {
                              onChange(
                                value.filter(val => val.id !== option.id),
                              );
                            } else {
                              onChange([...value, option]);
                            }
                          }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
            {type && type === 'paginatedSelect' && (
              <PaginatedMultiSelect
                hasInputWithRightMargin
                identifier={identifier}
                placeholder={placeholder}
                options={options}
                hasNextPage={hasNextPage}
                isNextPageLoading={isNextPageLoading}
                loadNextPage={loadNextPage}
                onSearchByTerm={onSearchByTerm}
                value={value}
                customItemLoadCheck={isItemLoaded}
                searchTerm={searchTerm}
                onChange={onChange}
              />
            )}
          </div>
        )}
      </DropDownContainer>
    </div>
  );
};

export default DrawerFilterType;
